import { render, staticRenderFns } from "./USC_21_018.vue?vue&type=template&id=4721f56e"
import script from "./USC_21_018.vue?vue&type=script&lang=js"
export * from "./USC_21_018.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports